export const settingsConstants = {
    SET_REFRESH_RATE: 'LISTS_SET_REFRESH_RATE',
    SET_SORT_OPTION: 'LISTS_SET_SORT_OPTION',
    SET_SHOPPING_MODE: 'LISTS_SET_SHOPPING_MODE',
    SET_GLOBAL_SEARCH: 'LISTS_SET_GLOBAL_SEARCH',
    MIN_REFRESH_DELAY: 1000,
    DEFAULT_REFRESH_DELAY: 2000,
    LOCAL_STORAGE_KEY_REFRESH_DELAY: 'LIST_REFRESH_DELAY'
};
